// Vendors
import { convertPxsToRems } from '@openbank/cf-ui-framework';
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import styled from 'styled-components';

const ErrorComponentStyled = styled.section`
  max-width: ${convertPxsToRems({ pixels: 682, base: 16 })};
  margin: 0 auto;
  text-align: center;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    margin: 0;
    max-width: 100%;
  }
`;
ErrorComponentStyled.displayName = 'ErrorComponentStyled';

export { ErrorComponentStyled };
